module.exports = __webpack_public_path__ + "static/media/beaux-villages.835a2d79.jpeg";